import { NATIVE_ADDRESS } from "@/constants/addresses";
import { STORAGE_KEYS, getStorageKey } from "@/libs/Storage";
import { GasPriceSetting } from "@/types/swap";
import { Token } from "@/types/tokens";
import { useCallback, useEffect, useMemo } from "react";
import { useLocalStorage } from "usehooks-ts";
import { useAccount } from "@/hooks/useAccount";

interface SwapSettingsContextInterface {
  slippage: number;
  gasPrice: GasPriceSetting;
}

const initSwapSettingsContext: SwapSettingsContextInterface = {
  slippage: 1, // 0 - 100
  gasPrice: { value: 0, option: 0 },
};

export const useSwapSettingStorage = () => {
  const { address, chain } = useAccount();

  const storageKey = useMemo(
    () =>
      getStorageKey(
        chain?.id,
        address ?? NATIVE_ADDRESS,
        STORAGE_KEYS.SWAP_SETTINGS
      ),
    [address, chain?.id]
  );

  const [swapSettings, setSwapSettings] =
    useLocalStorage<SwapSettingsContextInterface>(
      storageKey,
      initSwapSettingsContext
    );

  const { slippage, gasPrice } = useMemo(() => swapSettings, [swapSettings]);

  const setSlippage = useCallback(
    (slippage: number) => {
      const tmp = Object.assign({}, swapSettings);
      setSwapSettings({
        ...tmp,
        slippage,
      });
    },
    [setSwapSettings, JSON.stringify(swapSettings)]
  );

  const setGasPrice = useCallback(
    (gasPrice: GasPriceSetting) => {
      const tmp = Object.assign({}, swapSettings);
      setSwapSettings({
        ...tmp,
        gasPrice,
      });
    },
    [setSwapSettings, JSON.stringify(swapSettings)]
  );

  return {
    slippage,
    gasPrice,
    setSlippage,
    setGasPrice,
  };
};
